module.exports = __webpack_public_path__ + "img/BKNO3-After-e1447105333173-min.506a3a96.jpg";